import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getNotifications } from '../../actions/notificationAction';
import { Link } from 'react-router-dom';
import timeSince from '../../utils/timeSince';

const Notifications = () => {
    const dispatch = useDispatch();
    const { notifications, loading } = useSelector((state) => state.notifications);

    useEffect(() => {
        dispatch(getNotifications());
    }, [dispatch]);

    return (
        <div className="absolute w-80 bg-white rounded drop-shadow-xl right-14 top-14 border z-50 max-h-96 overflow-y-auto">
            <div className="absolute right-5 -top-2 rotate-45 h-4 w-4 bg-white rounded-sm border-l border-t"></div>

            <div className="flex flex-col w-full">
                {loading ? (
                    <div className="text-center p-4">Loading...</div>
                ) : notifications && notifications.length > 0 ? (
                    notifications.map((n) => (
                        <Link to={n.post ? `/post/${n.post._id}` : `/${n.sender.username}`} key={n._id} className="flex items-center gap-3 p-3 text-sm hover:bg-gray-50 border-b">
                            <img src={n.sender.avatar} alt="avatar" className="w-10 h-10 rounded-full object-cover" />
                            <div className="flex flex-col">
                                <span>
                                    <span className="font-semibold">{n.sender.username}</span> {n.type === 'like' && 'liked your post.'} {n.type === 'comment' && 'commented on your post.'} {n.type === 'follow' && 'started following you.'}
                                </span>
                                <span className="text-xs text-gray-400">{timeSince(new Date(n.createdAt))} ago</span>
                            </div>
                            {n.type !== 'follow' && n.post && (
                                <img src={n.post.image} alt="post" className="w-10 h-10 object-cover ml-auto" />
                            )}
                        </Link>
                    ))
                ) : (
                    <div className="text-center p-4 text-gray-500">No Notifications</div>
                )}
            </div>
        </div>
    )
}

export default Notifications